export type ParsedCsv = {
  headers: string[];
  normalizedHeaders: string[];
  rows: string[][];
};

export function normalizeHeader(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, '').trim();
}

export function parseCsv(text: string): ParsedCsv {
  const source = text.replace(/^\uFEFF/, '');
  const rows: string[][] = [];
  let current = '';
  let row: string[] = [];
  let inQuotes = false;

  for (let i = 0; i < source.length; i += 1) {
    const char = source[i];

    if (char === '"') {
      if (inQuotes && source[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === ',' && !inQuotes) {
      row.push(current);
      current = '';
      continue;
    }

    if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && source[i + 1] === '\n') {
        i += 1;
      }
      row.push(current);
      rows.push(row.map((cell) => cell.trim()));
      row = [];
      current = '';
      continue;
    }

    current += char;
  }

  if (current.length || row.length) {
    row.push(current);
    rows.push(row.map((cell) => cell.trim()));
  }

  const filteredRows = rows.filter((r) => r.some((cell) => cell.length > 0));
  if (!filteredRows.length) {
    throw new Error('CSV did not contain any rows.');
  }

  const headers = filteredRows[0].map((cell) => cell.trim());
  const normalizedHeaders = headers.map(normalizeHeader);
  const dataRows = filteredRows.slice(1).map((r) => {
    const copy = [...r];
    while (copy.length < headers.length) {
      copy.push('');
    }
    return copy;
  });

  return { headers, normalizedHeaders, rows: dataRows };
}
